import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Input } from "../ui/input";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "../ui/dialog";

const emptyBooking = { name: "", phone: "", service_needed: "", preferred_date: "", vehicle_year: "", vehicle_make: "", vehicle_model: "" };

export const BookingDialog = ({ open, onOpenChange, onSubmit }) => {
  const [booking, setBooking] = useState(emptyBooking);
  const [saving, setSaving] = useState(false);

  const set = (field) => (e) => setBooking({ ...booking, [field]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!booking.name.trim() || !booking.phone.trim()) {
      toast.error("Name and phone are required");
      return;
    }
    setSaving(true);
    const ok = await onSubmit({
      ...booking,
      service_needed: booking.service_needed || "Calendar Booking",
      vehicle_year: booking.vehicle_year || "-",
      vehicle_make: booking.vehicle_make || "-",
      vehicle_model: booking.vehicle_model || "-",
    });
    setSaving(false);
    if (ok) setBooking(emptyBooking);
  };

  const inputCls = "bg-[#0a0a0a] border-zinc-800 text-white h-10 rounded-sm";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#121212] border-zinc-800 text-white">
        <DialogHeader>
          <DialogTitle className="font-heading">Log Calendar Booking</DialogTitle>
          <DialogDescription className="text-zinc-500">
            Record a Google Calendar appointment so it shows up with your other leads.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <Input data-testid="booking-input-name" className={inputCls} placeholder="Customer name *" value={booking.name} onChange={set("name")} />
            <Input data-testid="booking-input-phone" type="tel" className={inputCls} placeholder="Phone *" value={booking.phone} onChange={set("phone")} />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <Input data-testid="booking-input-service" className={inputCls} placeholder="Service (optional)" value={booking.service_needed} onChange={set("service_needed")} />
            <Input data-testid="booking-input-date" type="date" className={`${inputCls} [color-scheme:dark]`} value={booking.preferred_date} onChange={set("preferred_date")} />
          </div>
          <div className="grid grid-cols-3 gap-4">
            <Input data-testid="booking-input-year" className={inputCls} placeholder="Year" value={booking.vehicle_year} onChange={set("vehicle_year")} />
            <Input data-testid="booking-input-make" className={inputCls} placeholder="Make" value={booking.vehicle_make} onChange={set("vehicle_make")} />
            <Input data-testid="booking-input-model" className={inputCls} placeholder="Model" value={booking.vehicle_model} onChange={set("vehicle_model")} />
          </div>
          <DialogFooter>
            <button
              data-testid="booking-save-button"
              type="submit"
              disabled={saving}
              className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white rounded-sm px-6 py-2.5 text-sm font-semibold transition-colors"
            >
              {saving && <Loader2 className="h-4 w-4 animate-spin" />}
              Log Booking
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
